import { CURRENT_CONFIG } from './environment';

// API Configuration
export const API_CONFIG = {
  BASE_URL: CURRENT_CONFIG.API_BASE_URL,
  ENDPOINTS: {
    SENTENCES: '/api/sentences',
    SENTENCES_BY_CATEGORY: '/api/sentences/category',
    LEARNING_PROGRESS: '/api/learning/progress',
    LEARNING_STATS: '/api/learning/stats'
  }
};

// Get auth headers
const getAuthHeaders = () => {
  const token = localStorage.getItem('token');
  return {
    'Content-Type': 'application/json',
    ...(token && { 'Authorization': `Bearer ${token}` })
  };
};

// Request cache for deduplication
const requestCache = new Map<string, Promise<Response>>();

// API Helper Functions
export const apiUrls = {
  sentences: (params?: { page?: number; limit?: number; category?: string }) => {
    const url = new URL(API_CONFIG.ENDPOINTS.SENTENCES, API_CONFIG.BASE_URL);
    if (params?.page !== undefined) url.searchParams.set('page', params.page.toString());
    if (params?.limit !== undefined) url.searchParams.set('limit', params.limit.toString());
    if (params?.category) url.searchParams.set('category', params.category);
    return url.toString();
  },
  
  sentencesByCategory: (category: string, params?: { page?: number; limit?: number }) => {
    const url = new URL(`${API_CONFIG.ENDPOINTS.SENTENCES_BY_CATEGORY}/${encodeURIComponent(category)}`, API_CONFIG.BASE_URL);
    if (params?.page !== undefined) url.searchParams.set('page', params.page.toString());
    if (params?.limit !== undefined) url.searchParams.set('limit', params.limit.toString());
    return url.toString();
  }
};

// Authenticated fetch wrapper with deduplication
export const authFetch = async (url: string, options: RequestInit = {}) => {
  const cacheKey = `${url}-${JSON.stringify(options)}`;
  
  // Return cached promise if exists
  if (requestCache.has(cacheKey)) {
    return requestCache.get(cacheKey)!.then(response => response.clone());
  }
  
  const requestPromise = fetch(url, {
    ...options,
    headers: {
      ...getAuthHeaders(),
      ...options.headers
    }
  });
  
  // Cache the promise
  requestCache.set(cacheKey, requestPromise);
  
  // Clean up cache after request completes
  requestPromise.finally(() => {
    setTimeout(() => requestCache.delete(cacheKey), 1000);
  });
  
  return requestPromise;
};
